import { apiClient } from "../utils/apiClient"
import {PUBLIC_EVENTS_URL} from "../config/api";

export interface PublicEventDetail extends PublicEvent {
    stages: Array<{
        id: string;
        name: string;
        price: number;
        totalQuantity: number;
        isActive: boolean;
    }>;
    termsConditions: string;
}

export interface PublicEvent {
    id: string;
    name: string;
    startDate: string;
    // Sales close when it passes
    endDate?: string;
    location: string;
    referencePriceFrom: number;
    whatsappContact: string;
    // Buyers request refunds from the organizer, not from SuperTicket
    refundContactEmail?: string;
    refundContactPhone?: string;
    description: string;
    category: string;
    status: string;
    imageUrl: string;
}

interface PaginatedResponse {
    content: PublicEvent[];
    totalElements: number;
    totalPages: number;
}

export const EVENT_CATEGORIES = [
    { id: 'ALL', label: 'Todos' },
    { id: 'CONCERT', label: 'Conciertos' },
    { id: 'PARTY', label: 'Fiestas' },
    { id: 'FESTIVAL', label: 'Festivales' },
    { id: 'THEATER', label: 'Teatro' },
    { id: 'STANDUP', label: 'Stand-up' },
    { id: 'ART', label: 'Arte' },
    { id: 'SPORTS', label: 'Deportes' },
    { id: 'FAMILY', label: 'Familia' },
    { id: 'CONFERENCE', label: 'Conferencias' },
    { id: 'OTHER', label: 'Otros' },
];

export const publicEventsService = {

    async getEvents(category: string = 'ALL', page: number = 0, size: number = 20) {
        try {
            const params = new URLSearchParams({
                page: page.toString(),
                size: size.toString(),
                sort: 'startDate,asc'
            });

            if (category && category !== 'ALL') {
                params.append('category', category);
            }

            const response = await apiClient(`${PUBLIC_EVENTS_URL}?${params.toString()}`);

            if (!response.ok) {
                throw new Error('Error fetching public events');
            }

            const data: PaginatedResponse = await response.json();
            return data;

        } catch (error) {
            console.error("Error in publicEventsService:", error);
            throw error;
        }
    },

    async getEventById(id: string) {
        const response = await fetch(`${PUBLIC_EVENTS_URL}/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error('No se pudo cargar el evento');
        }

        const data: PublicEventDetail = await response.json();
        return data;
    }
};